"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Number_1 = require("./Number");
/**
 * Ritorna una stringa random
 *
 * @param {number} [len=10]
 * @param {string} [characters='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789']
 * @returns {string}
 */
exports.randomString = (length = 10, characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
    let text = '';
    for (let i = 0; i < length; i++)
        text += characters.charAt(Number_1.randomInt(0, characters.length - 1));
    return text;
};
/**
 * Ritorna una stringa con il solo primo carattere maiuscolo
 *
 * @param {string} str
 * @returns {string}
 */
exports.ucfirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);
/**
 * Converte una stringa nel formato camel case
 *
 * @param {string} str
 * @returns {string}
 */
exports.toCamelCase = (str) => str ? str.replace(/[^A-Z0-9]+/ig, '').replace(/\s(.)/g, ($1) => $1.toUpperCase()).replace(/\s/g, '').replace(/^(.)/, ($1) => $1.toLowerCase()) : '';
exports.pluralize = (len, zero, one, multiple) => {
    len = len.length ? len.length : len;
    switch (len) {
        case 0: return zero;
        case 1: return one;
        default: return multiple;
    }
};
//# sourceMappingURL=String.js.map